import { render } from "./CreateElement.vue?vue&type=template&id=d01b73c4&scoped=true"
import script from "./CreateElement.vue?vue&type=script&lang=js"
export * from "./CreateElement.vue?vue&type=script&lang=js"

import "./CreateElement.vue?vue&type=style&index=0&id=d01b73c4&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d01b73c4"]])

export default __exports__